module.exports = "/_next/static/images/cimb-logo-985416be04ae0548e3d0d84b14bd1ed1.svg";